import React from 'react'
import { injectIntl } from 'react-intl'
import Logout from '../../../shared/components/Logout'
import Pages from '../pages'

class Header extends React.Component {
  render() {
    const logo = () => {
      if (this.props.logoUrl){
        return(<img src={this.props.logoUrl}
          style={{ maxHeight: parseInt(this.props.logoHeight || 80) }} />);
      }
    }

    const displayHelp = () => {
      if(this.props.wizard_url) {
        return (
          <a target="_blank" className="btn btn-warning help" href={this.props.wizard_url}>
            Help
          </a>
        )
      }
    }

    const displayLogout = () => {
      if (this.props.page === Pages.REGISTER_PAGE) return
      if (this.props.page === Pages.ADDRESS_PAGE) return
      if (this.props.page === Pages.FIREBASE_REGISTER_FORM_PAGE) return

      return <Logout />
    }

    return (
      <div className="header">
        {logo()}
        <div className="button__container">
          {displayHelp()}
          {displayLogout()}
        </div>
      </div>
    )
  }
}

export default injectIntl(Header)
